module.exports = __webpack_public_path__ + "static/V7_Logo_1-9117a8c5971c21d97d1236085b423a6d.png";